import {compose} from 'redux';
import {connect} from 'react-redux';
import {Field, reduxForm, SubmissionError} from 'redux-form';
import {Button, Form, Message, Segment} from 'semantic-ui-react';
import {useToasts} from 'react-toast-notifications';
import FormInput from '../shared/forms/input';
import {required} from '../shared/forms';
import {normalizeName} from '../shared/forms/normalizers';
import {updateUserData} from '../../redux/actions/user';

function UpdateUserDataForm(props) {
  const {handleSubmit, pristine, submitting, error} = props;
  const {addToast} = useToasts();

  async function submit(data) {
    try {
      let updated_data = {};
      for (let key in data) {
        if (
          data.hasOwnProperty(key) &&
          props.initialValues.hasOwnProperty(key) &&
          data[key] !== props.initialValues[key]
        ) {
          updated_data[key] = data[key];
        }
      }
      await props.updateUserData(updated_data);
      addToast('اطلاعات شما با موفقیت تغییر کرد.', {appearance: 'success'});
    } catch (error) {
      const errorMessage = error.message || 'تغییر اطلاعات انجام نشد.';
      throw new SubmissionError({_error: errorMessage});
    }
  }

  return (
    <Segment>
      {/*form error*/}
      {(error && !pristine) && (
        <Message
          error
          header={error}
          className={'text-center'}
        />
      )}

      {/*form*/}
      <Form onSubmit={handleSubmit(submit.bind(null))}>
        <Form.Group widths='equal'>
          <Field
            name='firstName'
            label='نام'
            component={FormInput}
            validate={required}
            normalize={normalizeName}
          />
          <Field
            name='lastName'
            label='نام خانوادگی'
            component={FormInput}
            validate={required}
            normalize={normalizeName}
          />
        </Form.Group>
        <Form.Group widths='equal'>
          <Field
            name='username'
            label='نام کاربری'
            component={FormInput}
          />
        </Form.Group>

        <Button
          type='submit'
          disabled={pristine || submitting}
          content='تغییر اطلاعات'
        />
      </Form>
    </Segment>
  );
}

function mapStateToProps({user}) {
  return {
    initialValues: {
      firstName: user.data.firstName,
      lastName: user.data.lastName,
      username: user.data.username !== `@${user.data.mobile}` ? user.data.username : ''
    }
  };
}

export default compose(
  connect(mapStateToProps, {updateUserData}),
  reduxForm({form: 'update-user-data', enableReinitialize: true})
)(UpdateUserDataForm);
